import { render } from "./AppIconGroup.vue?vue&type=template&id=97436478&scoped=true"
import script from "./AppIconGroup.vue?vue&type=script&lang=js"
export * from "./AppIconGroup.vue?vue&type=script&lang=js"

import "./AppIconGroup.vue?vue&type=style&index=0&id=97436478&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97436478"]])

export default __exports__